var googleMapStyles = [{
  elementType: 'geometry',
  stylers: [{
    color: '#e0e4eb'
  }]
}, {
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#4b4f63'
  }]
}, {
  elementType: 'labels.text.stroke',
  stylers: [{
    color: '#f5f5f5'
  }]
}, {
  featureType: 'administrative.land_parcel',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#a6a9ba'
  }]
}, {
  featureType: 'poi',
  elementType: 'geometry',
  stylers: [{
    color: '#dadfe7'
  }]
}, {
  featureType: 'poi',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#a6a9ba'
  }]
}, {
  featureType: 'poi.park',
  elementType: 'geometry',
  stylers: [{
    color: '#d0d7e1'
  }]
}, {
  featureType: 'poi.park',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#a6a9ba'
  }]
}, {
  featureType: 'road',
  elementType: 'geometry',
  stylers: [{
    color: '#f2f3f7'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#7e8195'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry',
  stylers: [{
    color: '#c5cdd8'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#616161'
  }]
}, {
  featureType: 'road.local',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#a6a9ba'
  }]
}, {
  featureType: 'transit.line',
  elementType: 'geometry',
  stylers: [{
    color: '#c4cdd8'
  }]
}, {
  featureType: 'transit.station',
  elementType: 'geometry',
  stylers: [{
    color: '#dadfe7'
  }]
}, {
  featureType: 'water',
  elementType: 'geometry',
  stylers: [{
    color: '#acb8c9'
  }]
}, {
  featureType: 'water',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#a5a9b9'
  }]
}];
export default googleMapStyles;